import { TableContainer } from '@shared/components'
import { Text } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Alert, Button, Flex, Modal, theme } from 'antd'
import { AnyObject } from 'antd/es/_util/type'
import { InfoCircle } from 'iconsax-react'

type Props = {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  loading?: boolean
  data?: AnyObject[]
}

export const DuplicatesModal = ({
  open,
  onConfirm,
  onCancel,
  loading,
  data
}: Props) => {
  const { t } = useLocales()
  const { token } = theme.useToken()

  return (
    <Modal
      title={
        <Flex gap={12} align="center">
          <InfoCircle variant="Bold" color={token.orange5} size={24} />
          <Text size={18} weight={600}>
            {t('import.duplicates_found')}
          </Text>
        </Flex>
      }
      open={open}
      onCancel={onCancel}
      width={960}
      centered
      footer={[
        <Button key="cancel" onClick={onCancel}>
          {t('buttons.cancel')}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          loading={loading}
          onClick={onConfirm}
        >
          {t('buttons.continue_anyway')}
        </Button>
      ]}
    >
      <Alert
        message={t('import.duplicates_warning_message')}
        description={t('import.duplicates_warning_description')}
        type="warning"
        className="mb-20"
      />

      <TableContainer
        showSearch={false}
        loading={loading}
        columns={[
          {
            title: t('import.duplicate_fields'),
            dataIndex: 'fields',
            render: (fields: string[]) => (fields || []).join(', ')
          },
          {
            title: t('import.affected_rows_in_file'),
            dataIndex: 'rows',
            render: (rows: number[]) => (rows || []).join(', ')
          }
        ]}
        data={{ results: data }}
        rowKey={(_, index) => index?.toString() ?? '0'}
      />
    </Modal>
  )
}
